import React, {useMemo, useState} from 'react';

import createCtx from 'coreUtils/createCtx';

import {GoogleMapsLibraryStatus} from 'brandComponents/GoogleMapsWrapper';

import {IStoreMarker} from '../Subcomponents/Marker';

import {IStoreLocatorContext, Store} from './IStoreLocatorContext';

export const [useStoreLocatorContext, StoreLocatorContext] = createCtx<IStoreLocatorContext>();

export const StoreLocatorProvider = ({children}: React.PropsWithChildren) => {
	const [stores, setStores] = useState<Store[]>([]);
	const [selectedStoreMarker, setSelectedStoreMarker] = useState<IStoreMarker|null>(null);
	const [map, setMap] = useState(null);
	const [center, setCenter] = useState({
		lat: 0,
		lng: 0,
	});
	const [libraryStatus, setLibraryStatus] = useState(GoogleMapsLibraryStatus.LOADING);

	const storesCount = useMemo(() => stores.length, [stores]);

	return (
		<StoreLocatorContext
			value={{
				stores,
				setStores,
				storesCount,
				selectedStoreMarker,
				setSelectedStoreMarker,
				map,
				setMap,
				center,
				setCenter,
				libraryStatus,
				setLibraryStatus
			}}
		>
			{/* Problem derived to React Types, for remove this ignore */}
			{/* we need to update the package on dev dependencies */}
			{/* @ts-ignore */}
			{children}
		</StoreLocatorContext>
	);
};
